export default __webpack_public_path__ + "static/media/slew_magenta.7f1bc9a0.svg";